<template>
	<div>
		<div class="comment-list" ref="commentList" v-infinite-scroll="()=>getList(++page)" :infinite-scroll-disabled="(loading || noMoreData || noData)">
			<div v-for="item in lists" class="item" :key="item.id">
				<div class="item-header">
					<div class="name">{{ item.nickname }}</div>
					<div class="time">{{ item.create_time }}</div>
					<el-popconfirm title="确认删除?" @onConfirm="deleteComment(item)">
						<div slot="reference" v-if="item.is_delete" class="delete-btn v-ml-5" v-loading="item.deleteLoading">删除</div>
					</el-popconfirm>
				</div>
				<div class="content v-color-gray">{{ item.content }}</div>
				<viewer v-if="item.images.length" class="reply-images" :images="item.images" :options="{ zIndex: 20000, transition: false, toolbar: false, fullscreen: false }">
					<img class="img" v-for="(img, index) in item.images" :key="index" :src="img" />
				</viewer>
			</div>
			<div v-if="noMoreData" class="no-more-data">没有更多数据了...</div>
			<div v-if="noData" class="no-data">暂无评论数据...</div>
			<div v-loading="loading" element-loading-text="评论数据加载中.."></div>
		</div>
		<div class="area">
			<el-input type="textarea" rows="3" v-model="comment" resize="none" placeholder="请输入回复内容"></el-input>
			<div v-show="images.length < 3" class="upload-img" @click="selectFiles">
				<i class="iconfont icon-camera"></i>
				<div class="label">添加图片</div>
			</div>
		</div>
		<div class="comment-images">
			<v-upload-image ref="vUploadImage" v-model="images" :control="false" :sortable="true" :max="3"></v-upload-image>
		</div>
		<div class="comment-btn-box v-mt-10">
			<el-button :disabled="!comment.length" size="small" type="primary" @click="doSubmit" :loading="doSubmitLoading">提交评论</el-button>
		</div>
	</div>
</template>

<script>
	import 'viewerjs/dist/viewer.css';
	import Viewer from 'v-viewer';
	import Vue from 'vue';

	Vue.use(Viewer, {
		defaultOptions: {},
	});
	export default {

		props: {
			commentId: String,
			worksId: Number,
			materialId: Number
		},

		data() {
			return {
				loading: false,
				lists: [],
				page: 1,
				noData: false,
				noMoreData: false,
				images: [],
				comment: '', //评论内容
				doSubmitLoading: false,
			}
		},

		created() {
			this.getList()
		},

		methods: {
			//列表
			async getList(page) {
				this.loading = true;
				this.page = page ? page : this.page;
				try {
					let res = await this.api.comment.getReply({
						comment_id: this.commentId,
						page: this.page,
						page_size: 10,
					});
					this.lists = this.page === 1 ? res.data.data : this.lists.concat(res.data.data);
					this.noData = this.page === 1 && res.data.data.length === 0;
					this.noMoreData = this.page > 1 && res.data.data.length === 0;
				} catch (e) {
					console.error(e);
				}
				this.loading = false;
			},

			//选择上传图片
			selectFiles() {
				this.$refs.vUploadImage.chooseFile();
			},

			//删除评论
			async deleteComment(row) {
				this.$set(row, 'deleteLoading', true);
				try {
					await this.api.comment.delete({id: row.id});
					this.lists = this.lists.filter(item => item.id != row.id)
					this.$message.success('删除成功');
				} catch (e) {
					console.error(e);
				}
				this.$set(row, 'deleteLoading', false);
			},


			//发表评论
			async doSubmit() {
				this.doSubmitLoading = true;
				try {
					await this.api.comment.create({
						material_id: this.materialId,
						content: this.comment,
						works_id: this.worksId,
						type: 2,
						reply_id: this.commentId,
						images: this.images.map((item) => item.key),
					});
					this.comment = '';
					this.images = [];
					this.getList(1);
					this.$refs.commentList.scrollTop = 0;
					this.$message.success('提交成功');
				} catch (e) {
					console.error(e);
				}
				this.doSubmitLoading = false;
			},
		}
	}
</script>

<style scoped>
	/deep/ .el-textarea__inner {
		padding: 15px;
	}

	.comment-list {
		margin-bottom: 20px;
		font-size: 14px;
		height: 200px;
		overflow-y: auto;
	}

	.comment-list .lists {
		width: 100%;
	}

	.comment-list .item {
		font-size: 14px;
		padding-bottom: 15px;
		margin-bottom: 15px;
		border-bottom: 1px solid #eee;
	}

	.comment-list .item-header {
		display: flex;
		margin-bottom: 10px;
		align-items: center;
	}

	.comment-list .item-header .name {
		color: #333;
		margin-right: 20px;
	}

	.comment-list .item-header .time {
		flex: 1;
		font-size: 12px;
		color: #666;
	}

	.comment-list .item .content {
		flex: 1;
	}

	.comment-list .item .view {
		cursor: pointer;
		color: #409eff;
	}

	.comment-list .item .view:hover {
		text-decoration: underline;
	}

	.comment-list .item .delete-btn {
		font-size: 12px;
		color: #3582d1;
		cursor: pointer;
	}

	.comment-list .item .delete-btn:hover {
		text-decoration: underline;
	}

	.no-more-data {
		display: flex;
		height: 30px;
		font-size: 12px;
		color: #999;
		justify-content: center;
		align-items: center;
	}

	.no-data {
		display: flex;
		height: 100%;
		font-size: 12px;
		color: #999;
		justify-content: center;
		align-items: center;
	}

	.comment-btn-box {
		display: flex;
		justify-content: flex-start;
	}

	.area {
		position: relative;
	}

	.area .upload-img {
		position: absolute;
		top: 0;
		right: 0;
		height: 100%;
		width: 100px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		user-select: none;
	}

	.area .iconfont {
		font-size: 24px;
	}

	.comment-images {
		margin-top: 10px;
	}

	.reply-images {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		margin-top: 10px;
	}

	.reply-images .img {
		display: block;
		width: 50px;
		height: 50px;
		margin-right: 10px;
		margin-bottom: 10px;
		cursor: pointer;
	}

	.reply-images .img:last-child {
		margin-left: 0;
	}
</style>